import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_AD_UNITS_PRODUCT_ENABLED: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitsProductEnabled($input: UpdateAdUnitsProductEnabledInput!) {
    updateAdUnitsProductEnabled(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
